// canvasWillReadFrequently は他のimportよりも先に評価する必要があるため先頭に置く
import 'src/lib/canvasWillReadFrequently';
// ライブラリ CSS を Vue コンポーネントより先に読み込む（スタイル上書き順の保証）
import 'src/style/libs.css';
import 'floating-vue/dist/style.css';

import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import router from 'src/router';
import App from 'src/App.vue';

import { Multipane, MultipaneResizer } from 'src/components/lib/multipane';
import MyCalendar from 'src/components/lib/MyCalendar.vue';
import ExtremeMap from 'src/components/lib/ExtremeMap/index.vue';
import Modal from 'src/components/lib/Modal.vue';
import ModalImageView from 'src/components/lib/ModalImageView.vue';
import TagModal from 'src/components/lib/TagModal.vue';
import LoadWaitSpinner from 'src/components/lib/LoadWaitSpinner.vue';
import Pagination from 'src/components/lib/Pagination.vue';
import MoviePlayer from 'src/components/lib/MoviePlayer/index.vue';
import MoviePlayerCompareMode from 'src/components/lib/MoviePlayerCompareMode/index.vue';
import AdminListTable from 'src/components/lib/AdminListTable.vue';

const app = createApp(App);

app.use(router);
app.use(FloatingVue);

// PascalCase で登録する。Vue3 の resolveComponent は kebab 使用（<multipane>）を
// capitalize(camelize(name)) で PascalCase 登録名へ正規化して解決できるため、
// PascalCase 登録なら PascalCase・kebab 両方の使用箇所で解決可能。
// （kebab 登録だと <Multipane> のような PascalCase 使用が解決できず素の要素になる）
app.component('Multipane', Multipane);
app.component('MultipaneResizer', MultipaneResizer);
app.component('MyCalendar', MyCalendar);
app.component('ExtremeMap', ExtremeMap);
app.component('Modal', Modal);
app.component('ModalImageView', ModalImageView);
app.component('TagModal', TagModal);
app.component('LoadWaitSpinner', LoadWaitSpinner);
app.component('Pagination', Pagination);
app.component('MoviePlayer', MoviePlayer);
app.component('MoviePlayerCompareMode', MoviePlayerCompareMode);
app.component('AdminListTable', AdminListTable);

app.mount('#app');
